import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { extractPollReportParamsFromUrl, downloadPollReportFile, fetchPollReportDetails } from '../../service/polls.service';
import { REPORT_DOWNLOAD_CLASS } from '../../constants/dom.constants';

const DISPLAY_MESSAGES = {
  initial: 'Poll report download in progress...',
  invalidParam: 'Invalid parameters.',
  downloadFailed: 'Poll report download failed.',
  downloadSuccess: 'Poll report successfully downloaded.'
};

const PollReportDownloader = () => {
  const [searchParams] = useSearchParams();
  const [displayMessage, setDisplayMessage] = useState(DISPLAY_MESSAGES.initial);

  useEffect(() => {
    const downloadPollReport = async () => {
      const { authToken, zoomMeetingUuid } = extractPollReportParamsFromUrl(searchParams);
      if (!authToken || !zoomMeetingUuid) {
        setDisplayMessage(DISPLAY_MESSAGES.invalidParam);
        return;
      }

      const { success: pollReportData, error } = await fetchPollReportDetails({ zoomMeetingUuid, authToken });
      if (error!==null) {
        setDisplayMessage(DISPLAY_MESSAGES.downloadFailed);
        return;
      }

      await downloadPollReportFile(pollReportData);
      setDisplayMessage(DISPLAY_MESSAGES.downloadSuccess);
    };
    
    downloadPollReport();
  }, [searchParams.toString()]);

  return <div className={REPORT_DOWNLOAD_CLASS}>{displayMessage}</div>;
};

export default PollReportDownloader;
